<template>
  <div class="content-inside">
    <div v-if="initializing">
      Please wait...
    </div>
    <div v-else>
      <h5 id="target-segment-header" class="mb-5">Target your audience in the same group through setting up a segment
      </h5>
      <div class="modal-form">
        <b-row>
          <b-col>
            <b-row>
              <b-col md="4">
                <h6 class="main-label">Title</h6>
              </b-col>
              <b-col>
                <b-form-group id="targetSegmentTitleGroup" label="Target Segment Title" label-for="targetSegmentTitle"
                  :invalid-feedback="errorMessage('name')" :state="isValid('name')" class="secondary-label">
                  <b-form-input id="targetSegmentTitle" type="text" maxlength="50"
                    v-model.trim="form.targetSegmentTitle" required>
                  </b-form-input>
                </b-form-group>
                <b-form-group id="descriptionGroup" :label="'Description (Optional) - ' + descriptionCounter"
                  label-for="description" class="secondary-label" :invalid-feedback="errorMessage('description')"
                  :state="isValid('description')">
                  <b-form-textarea id="description" v-model.trim="form.targetSegmentDescription"
                    placeholder="Enter description" :rows="3" :maxlength="targetSegmentDescriptionMaxLength"
                    :max-rows="6">
                  </b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <hr class="form-divider">
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <h6 class="main-label">Upload CSV</h6>
              </b-col>
              <b-col :md="!form.csv ? '8' : '6'">
                <b-form-group :invalid-feedback="errorMessage('csv')" :state="isValid('csv')">
                  <b-file v-model="form.csv" accept=".csv" :disabled="isDisabledUploadCSV" ref="targetSegmentCsv"
                    @input="calculateFileSize"></b-file>
                </b-form-group>
              </b-col>
              <b-col v-if="form.csv" md="2" class="px-0">
                <b-button class="bg-transparent border-0 text-danger shadow-none" @click="clearCsvFile" title="Remove">
                  <img src="@/assets/images/u_trash-alt.svg" alt="Remove" width="20" class="mr-2"> <small>Remove</small>
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <hr class="form-divider">
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <h6 class="main-label">Gender</h6>
              </b-col>
              <b-col>
                <div>

                  <b-form-checkbox v-model="selectAllGender" @click.native.stop class="checkbox-group"
                    :disabled="!!form.csv">All</b-form-checkbox>
                  <b-form-checkbox-group stacked v-model="form.selectedGender" name="gender"
                    :options="form.genderOptions" class="checkbox-group" :disabled="!!form.csv">
                  </b-form-checkbox-group>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <hr class="form-divider">
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <h6 class="main-label">Age Group</h6>
              </b-col>
              <b-col>
                <div>
                  <b-form-checkbox v-model="selectAllAgeGroup" @click.native.stop class="checkbox-group"
                    :disabled="!!form.csv"><span>All</span>
                  </b-form-checkbox>
                  <b-form-checkbox-group stacked v-model="form.selectedAgeGroup" name="ageGroup"
                    :options="form.ageGroupOptions" class="checkbox-group" :disabled="!!form.csv">
                  </b-form-checkbox-group>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <hr class="form-divider">
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <h6 class="main-label">Birth Month</h6>
              </b-col>
              <b-col>
                <div>
                  <b-row no-gutters>
                    <b-col cols="4">
                      <b-form-checkbox v-model="selectAllBirthMonth" @click.native.stop class="checkbox-group"
                        :disabled="!!form.csv"><span>All</span>
                      </b-form-checkbox>
                      <b-form-checkbox-group stacked v-model="form.selectedBirthMonth" name="birthMonth"
                        :options="form.birthMonthOptions.slice(0, 7)" class="checkbox-group" :disabled="!!form.csv">
                      </b-form-checkbox-group>
                    </b-col>
                    <b-col class="mt-1 ml-4">
                      <b-form-checkbox-group stacked v-model="form.selectedBirthMonth" name="birthMonth"
                        :options="form.birthMonthOptions.slice(7, 13)" class="checkbox-group" :disabled="!!form.csv">
                      </b-form-checkbox-group>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <hr class="form-divider">
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <h6 class="main-label">Top Customers</h6>
              </b-col>
              <b-col>
                <div>
                  <b-form-select id="topCustomers" v-model="form.selectedTopCustomers"
                    :options="form.topCustomersOptions" :disabled="!!form.csv" />
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2 mt-2" v-show="false">
              <b-col>
                <hr class="form-divider">
              </b-col>
            </b-row>
            <b-row v-show="false">
              <b-col md="4">
                <h6 class="main-label">Allow Prospects</h6>
              </b-col>
              <b-col>
                <div>
                  <switches v-model="form.allowProspects" theme="custom" color="primary" type-bold="true"
                    text-enabled="On" text-disabled="Off" style="top: -18px;" class="target-segment-switch"
                    :disabled="!!form.csv">
                  </switches>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2 mt-2" v-show="false">
              <b-col>
                <hr class="form-divider">
              </b-col>
            </b-row>
            <b-row v-show="false">
              <b-col md="4">
                <h6 class="main-label">Allow New Members</h6>
              </b-col>
              <b-col>
                <div>
                  <switches v-model="form.allowNewMembers" theme="custom" color="primary" type-bold="true"
                    text-enabled="On" text-disabled="Off" class="target-segment-switch">
                  </switches>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2 mt-2">
              <b-col>
                <hr class="form-divider">
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <h6 class="main-label">No Previous Month Transaction Only</h6>
              </b-col>
              <b-col>
                <div>
                  <switches v-model="form.allowNoPreviousMonthTransaction" theme="custom" color="primary"
                    type-bold="true" text-enabled="On" text-disabled="Off" class="target-segment-switch"
                    :disabled="!!form.csv">
                  </switches>
                </div>
              </b-col>
            </b-row>
            <b-row class="mb-2 mt-2">
              <b-col>
                <hr class="form-divider">
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <b-button @click="saveTargetSegment" size="lg" variant="primary" class="save-button mt-5" type="submit"
                  :disabled="loading" :block="true"> {{ loading ? 'Saving...' : 'Save' }}
                </b-button>
              </b-col>
              <b-col cols="4">
                <b-button size="lg" variant="secondary" class="save-button mt-5" type="button"
                  :to="{ path: '/customers/target-segment' }" :block="true"> Back to List
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col></b-col>
        </b-row>
      </div>
    </div>

  </div>
</template>

<script>
import Switches from "vue-switches";
import _ from "lodash";
import { mapState } from "vuex";
import notification from "@/services/notification";

export default {
  name: "NewTargetSegment",
  data() {
    return {
      targetSegmentDescriptionMaxLength: 200
    };
  },
  components: {
    Switches
  },
  created: function () {
    this.fetchBarangays();
  },
  computed: {
    units() {
      const filtered = this.form.barangayList.filter(({ name }) => {
        return name.toLowerCase();
      });
      return _.groupBy(filtered, "unit");
    },
    checkedBarangaysLength() {
      let barangays = this.form.barangayList.filter(
        barangay => barangay.checked
      );
      return barangays.length;
    },
    selectAllGender: {
      get: function () {
        return this.form.genderOptions
          ? this.form.selectedGender.length ===
          this.form.genderOptions.length
          : false;
      },
      set: function (checked) {
        let selectedGender = [];

        if (checked) {
          _.forEach(this.form.genderOptions, function (gender) {
            selectedGender.push(gender.value);
          });
        }

        this.form.selectedGender = selectedGender;
      }
    },
    selectAllAgeGroup: {
      get: function () {
        return this.form.ageGroupOptions
          ? this.form.selectedAgeGroup.length ===
          this.form.ageGroupOptions.length
          : false;
      },
      set: function (checked) {
        let selectedAgeGroup = [];

        if (checked) {
          _.forEach(this.form.ageGroupOptions, function (ageGroup) {
            selectedAgeGroup.push(ageGroup.value);
          });
        }

        this.form.selectedAgeGroup = selectedAgeGroup;
      }
    },
    selectAllBirthMonth: {
      get: function () {
        return this.form.birthMonthOptions
          ? this.form.selectedBirthMonth.length ===
          this.form.birthMonthOptions.length
          : false;
      },
      set: function (checked) {
        let selectedBirthMonth = [];

        if (checked) {
          _.forEach(this.form.birthMonthOptions, function (
            birthMonth
          ) {
            selectedBirthMonth.push(birthMonth.value);
          });
        }

        this.form.selectedBirthMonth = selectedBirthMonth;
      }
    },
    descriptionCounter: {
      get: function () {
        if (this.form.targetSegmentDescription != null) {
          return (
            this.form.targetSegmentDescription.length +
            " / " +
            this.targetSegmentDescriptionMaxLength
          );
        }
        return "0 / " + this.guidelinesMaxLength;
      }
    },
    ...mapState("customerTargetSegment", [
      "targetSegment",
      "initializing",
      "loading",
      "errors",
      "form",
      "action"
    ]),
    isDisabledUploadCSV: {
      get() {
        return this.form.selectedGender.length > 0
          || this.form.selectedAgeGroup.length > 0
          || this.form.selectedBirthMonth.length > 0
          || this.form.selectedTopCustomers
          || this.form.allowNoPreviousMonthTransaction
      }
    }
  },
  methods: {
    clickAll() {
      let barangays = this.form.barangayList;
      if (barangays.find(barangay => !barangay.checked)) {
        barangays.forEach(barangay => (barangay.checked = true));
      } else {
        barangays.forEach(barangay => (barangay.checked = false));
      }
    },
    clickParent(unit) {
      let barangays = this.form.barangayList.filter(
        barangay => barangay.unit == unit[0].unit
      );
      if (barangays.find(barangay => !barangay.checked)) {
        barangays.forEach(barangay => (barangay.checked = true));
      } else {
        barangays.forEach(barangay => (barangay.checked = false));
      }
    },
    fetchBarangays: function () {
      let self = this;
      self.form.barangayList.forEach(barangay => {
        self.$set(barangay, "checked", false);
      });
    },
    toBase64(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          return resolve(e.target.result.split(",")[1]);
        };
      });
    },
    async saveTargetSegment() {
      if (this.form.csv && this.isDisabledUploadCSV) {
        notification.warning("Audience cannot be created. To proceed, you can only use any of the available filters or upload your own segment using a CSV file.");
      } else {
        await this.$store.commit("customerTargetSegment/errors", null);

        let payload = {
          name: this.form.targetSegmentTitle,
          description: this.form.targetSegmentDescription,
          visibility: true,
          gender: this.form.selectedGender,
          birth_month: this.form.selectedBirthMonth,
          age_group: this.form.selectedAgeGroup,
          top_customer: this.form.selectedTopCustomers,
          prospect: this.form.allowProspects,
          new_member: this.form.allowNewMembers,
          no_previous_month_transaction: this.form
            .allowNoPreviousMonthTransaction,
          branches: null
        };

        if (this.form.csv) {
          payload['csv'] = await this.toBase64(this.form.csv);
        }

        this.$parent.save(payload);
      }

    },
    isValid(field) {
      if (this.errors == null) {
        return false;
      }
      return !this.errors.errors[field];
    },
    errorMessage(field) {
      if (this.errors == null) {
        return "";
      }

      return this.errors.errors[field];
    },
    clearCsvFile() {
      this.$store.commit("customerTargetSegment/resetCsvError");
      this.$refs.targetSegmentCsv.reset();
      this.form.csv = null;
    },
    calculateFileSize(file) {
      if (this.form.csv && this.isDisabledUploadCSV) {
        notification.warning("Uncheck any pre-determined filter if you wish to upload a CSV file. In-compliance with Data Privacy Act, please ensure that the CSV file only includes those who opted-in.");
      } else if (file) {
        const size = ((file.size / 1024) / 2014).toFixed(4);
        if (size > 5) this.$store.commit("customerTargetSegment/errors", { errors: { csv: "Please upload a file less than 5mb." } });
        else this.$store.commit("customerTargetSegment/resetCsvError");
      }
    }
  }
};
</script>

<style lang="scss">
#target-segment-header {
  font-family: MainFontRegular, sans-serif;
  font-size: 14px;
  color: #2a2a2a;
}

.checkbox-group {
  font-family: MainFontRegular, sans-serif;
  font-size: 13px;
  color: #2a2a2a;
}

.target-segment-switch {
  position: absolute;
  top: -18px;
}

.main-checkbox {
  font-family: MainFontBold, sans-serif;
  font-size: 13px;
  color: #2a2a2a;
}

.selected-branches-length {
  font-size: 13px;
  font-family: MainFontRegular, sans-serif;
  margin-top: 5px;
}

.accordion-header {
  font-family: MainFontBold, sans-serif;
  font-size: 12px;
  color: #2a2a2a;

  &:hover {
    color: #2a2a2a;
  }
}

.collapse-expand-icon {
  margin-top: 3px;
  width: 12px;
  height: 12px;
}

.collapsed>.when-opened,
:not(.collapsed)>.when-closed {
  display: none;
}

.check-all-locations {
  margin-right: 0px;
  margin-bottom: 0px;
  margin-left: 0px;
  margin-top: 4px;
}

.location {
  font-family: MainFontRegular, sans-serif;
  font-size: 13px;
  color: #40485f;
}
</style>
